import { render, staticRenderFns } from "./UserFragment.vue?vue&type=template&id=2eab4719&"
import script from "./UserFragment.vue?vue&type=script&lang=js&"
export * from "./UserFragment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports